import { render, staticRenderFns } from "./DocumentoPage.vue?vue&type=template&id=143a8657"
import script from "./DocumentoPage.js?vue&type=script&lang=js&external"
export * from "./DocumentoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports